exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form[data-v-27deab3c]{min-height:400px}.instructions[data-v-27deab3c]{box-sizing:border-box;width:100%;margin-top:20px}.range[data-v-27deab3c]{align-items:center;font-size:16px}.range-slider[data-v-27deab3c]{width:100%}", ""]);

// exports
